/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for PaymentMode controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetPaymentModesResponse, GetPaymentModeSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PaymentModeService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getPaymentModes(searchTerm?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPaymentModesResponse>;
    getPaymentModes(searchTerm?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPaymentModesResponse>>;
    getPaymentModes(searchTerm?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPaymentModesResponse>>;
    getPaymentModes(searchTerm?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/PaymentMode`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getPaymentModeSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPaymentModeSelectResponse>;
    getPaymentModeSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPaymentModeSelectResponse>>;
    getPaymentModeSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPaymentModeSelectResponse>>;
    getPaymentModeSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/PaymentMode/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
